import axios from 'axios';
import {
  IFieldCountriesDataOptions,
  IFieldDataOptions,
} from '../Types/FieldDataConfig';
import { useSearchParams } from 'react-router-dom';

const api_url_njs = process.env.REACT_APP_ROOT_DOMAIN;
const api_auth_username_njs = process.env.REACT_APP_API_USER_NJS!;
const api_auth_password_njs = process.env.REACT_APP_API_PASSWORD_NJS!;

const root_url = api_url_njs;
const api_auth_username = api_auth_username_njs;
const api_auth_password = api_auth_password_njs;

const nodeServerEndpoint = '/api/leasing-form';

const defaultUrlEnpoint = nodeServerEndpoint;

async function getToken() {
  const queryParameters = new URLSearchParams(window.location.search);
  const guid = queryParameters.get('guid');

  try {
    const tokenResponse: any = await axios.post(
      root_url + '/generate-token',
      {
        clientId: '123456',
        guid: guid,
        isForm: true,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }
    );

    return tokenResponse.data.token;
  } catch (error) {
    console.log(error);
  }
}

export async function getHeadersAPI() {
  //const token = sessionStorage.getItem("token");
  const token = await getToken();
  return {
    Authorization: `Bearer ${token}`,
  };
}

export const getAllRetailerData = async (applicationGuid: string) => {
  return axios
    .get(
      root_url +
        defaultUrlEnpoint +
        '/GetRetailerThemeByGuid?guid=' +
        applicationGuid,
      {
        headers: await getHeadersAPI(),
      }
    )
    .then((res) => {
      // console.log(res);
      // console.log(res.data);
      const JSONobject = res.data;

      return JSONobject;
    });
};

export const getCountryListApiCall = async () => {
  const countryList: IFieldCountriesDataOptions[] = [];
  return axios
    .get(root_url + '/api/getCountries', {
      headers: await getHeadersAPI(),
    })
    .then((res) => {
      return res.data.map((_: any) => {
        return {
          label: _.CONTRYDESC,
          value: +_.ID,
          IsEU: _.IsEU,
        };
      });
    })
    .catch((err) => {
      countryList.push({
        label: 'Nederlandse',
        value: 1,
        IsEU: true,
      });
    });
};

export const getMonthList = async () => {
  const countryList: IFieldDataOptions[] = [];
  return axios
    .get(root_url + '/api/getMonths', {
      headers: await getHeadersAPI(),
    })
    .then((res) => {
      return res.data.map((_: any) => {
        return {
          text: _.Label_NL,
          value: _.Id,
        };
      });
    })
    .catch((err) => {
      countryList.push({
        label: 'Januari',
        value: 1,
      });
    });
};

export const saveStepData = async (urlToSave: string, dataToSave: any) => {
  axios
    .post(urlToSave, dataToSave, {
      headers: await getHeadersAPI(),
    })
    .then((res) => {
      // console.log(res);
    });
};

export const getAddressApiCall = async (
  zipCode: string | number,
  houseNo: string | number
) => {
  return axios
    .get(
      root_url + `/api/getAddress?zipCode=${zipCode}&houseNumber=${houseNo}`,
      {
        headers: await getHeadersAPI(),
      }
    )
    .then((res) => {
      return {
        city: res.data.city.trim(),
        street: res.data.street.trim(),
      };
    })
    .catch((err) => {
      const returnMsg = {
        city: 'De combinatie van postcode en huisnummer is incorrect',
        street: 'De combinatie van postcode en huisnummer is incorrect',
      };
      return Promise.reject(returnMsg);
    });
};

export const getOthersNetIncomeListApiCall = async () => {
  return axios
    .get(root_url + '/api/getOtherIncomeTypes/', {
      headers: await getHeadersAPI(),
    })
    .then((res) => {
      return res.data.map((_: any) => {
        return {
          label: _.Label,
          value: _.Id,
        };
      });
    });
};

export const validateIBANApiCall = async (ibanToValidate: string) => {
  return await axios
    .get(root_url + '/api/getIBAN/' + ibanToValidate, {
      headers: await getHeadersAPI(),
    })
    .then((res) => {
      return res.data.Result.IsValid;
    })
    .catch((error) => {
      console.log('error trying to validate IBAN');
    });
};

//RECAPTCHA
export const verifyRecaptchaTokenV3 = async (token: string, action: string) => {
  try {
    const verificationUrl = root_url + '/api/recaptcha/v3/verify';

    const response = await axios.post(
      verificationUrl,
      {
        token: token,
        action: action,
      },
      {
        headers: await getHeadersAPI(),
      }
    );

    // Retorna a resposta do seu backend (ex: { isHuman: true, score: 0.9 })
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(
        'API Error while verifying reCAPTCHA token:',
        error.response?.data || error.message
      );
    } else {
      console.error('An unexpected error occurred:', error);
    }
    return { isHuman: false, error: 'Failed to verify token' };
  }
};

export const verifyRecaptchaTokenV2 = async (token: string, action: string) => {
  try {
    const verificationUrl = root_url + '/api/recaptcha/v2/verify';

    const response = await axios.post(
      verificationUrl,
      {
        token: token,
        action: action,
      },
      {
        headers: await getHeadersAPI(),
      }
    );

    // Retorna a resposta do seu backend (ex: { isHuman: true, score: 0.9 })
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(
        'API Error while verifying reCAPTCHA token:',
        error.response?.data || error.message
      );
    } else {
      console.error('An unexpected error occurred:', error);
    }
    return { isHuman: false, error: 'Failed to verify token' };
  }
};
